import { render, staticRenderFns } from "./freightRulesAdd.vue?vue&type=template&id=ae53b386&scoped=true"
import script from "./freightRulesAdd.vue?vue&type=script&lang=js"
export * from "./freightRulesAdd.vue?vue&type=script&lang=js"
import style0 from "./freightRulesAdd.vue?vue&type=style&index=0&id=ae53b386&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae53b386",
  null
  
)

export default component.exports